import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section background="white" className="text-center" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#4A3B32] mb-6" data-id="element-25">
          ¿Lista para sentirte ligera?
        </h2>
        <p className="text-lg text-[#5D5D5D] mb-8" data-id="element-26">
          No dejes pasar otro día sintiéndote incómoda en tu propia piel. <br data-id="element-27" />
          La solución está a un clic de distancia.
        </p>

        <Button onClick={scrollToOffer} size="lg" className="shadow-xl shadow-[#14B8A6]/30 px-12 py-5 text-lg" data-id="element-28">
          SÍ, QUIERO DESINFLAMARME AHORA <ArrowRight className="ml-2" data-id="element-29" />
        </Button>

        <p className="mt-4 text-sm text-[#5D5D5D]" data-id="element-30">
          Precio especial de{' '}
          <span className="font-bold text-[#14B8A6]" data-id="element-31">$9.97</span> termina
          pronto.
        </p>
      </div>
    </Section>;
}